import { JSONSchemaProp } from 'models';
import { translateEnumItemInScheme } from './translateEnumItemInScheme';

export const getOptionsFromEnum = (prop?: JSONSchemaProp, translationsProp?: JSONSchemaProp) => prop?.enum?.length ? prop.enum.map(key => ({ key: key, value: translateEnumItemInScheme(translationsProp || prop, key) })) : [];

